

import ClinicAdminDashboard from "../Components/Dashboard/Dashboard";
import StaffList from "../Components/ManageStaff/staff-list";
import StaffEdit from "../Components/ManageStaff/staff.edit";
import StaffView from "../Components/ManageStaff/staff-view";
import StaffAdd from "../Components/ManageStaff/staff-add";

import ChangePassword from "../Components/MyProfile/change-password";
import AddInventory from "../Components/PharmacyInventory/AddInventory";
import AdjustInventory from "../Components/PharmacyInventory/AdjustInventory";
import InventoryHistory from "../Components/PharmacyInventory/InventoryHistory";
import UpdateInventory from "../Components/PharmacyInventory/UpdateInventory";
import ViewInventory from "../Components/PharmacyInventory/ViewInventory";
// import Ledger from "../Components/PharmacyLedger/Ledger";
import PatientLedger from "../Components/PharmacyLedger/PatientLedger";
import ViewPatientLedger from "../Components/PharmacyLedger/ViewPatientLedger";
import MinStockAlert from "../Components/PharmacyManageStocks/MinStockAlert";
import NearToExpire from "../Components/PharmacyManageStocks/NearToExpire";
import Stocks from "../Components/PharmacyManageStocks/Stocks";
import StocksExpired from "../Components/PharmacyManageStocks/StocksExpired";
import ManageTax from "../Components/PharmacyManageTax/ManageTax";
import AddItem from "../Components/PharmacyMedicineAdd/AddItem";
import AddMedicine from "../Components/PharmacyMedicineAdd/AddMedicine";
import UpdateMedicine from "../Components/PharmacyMedicineAdd/UpdateMedicine";
import ViewMedicine from "../Components/PharmacyMedicineAdd/ViewMedicine";
import AddOTC from "../Components/PharmacyOTC/AddOTC";
import OTCProducts from "../Components/PharmacyOTC/OTCProducts";
import UpdateOTC from "../Components/PharmacyOTC/updateOTC";
import ViewOTC from "../Components/PharmacyOTC/viewOTC";
import NewSales from "../Components/PharmacySales/NewSales";
import ReturnSales from "../Components/PharmacySales/ReturnSales";
import SalesHistory from "../Components/PharmacySales/SalesHistory";
import Transactions from "../Components/PharmacySales/Transactions";
import ViewSale from "../Components/PharmacySales/ViewSale";
import AddStock from "../Components/PharmacyStocks/AddSock";
import ReturnPurchase from "../Components/PharmacyStocks/returnPurchase";
import StockItemsList from "../Components/PharmacyStocks/StockItemsList";
import StockList from "../Components/PharmacyStocks/StockList";
import UpdateStock from "../Components/PharmacyStocks/UpdateStock";
import ViewStock from "../Components/PharmacyStocks/ViewStock";
import ViewStockItem from "../Components/PharmacyStocks/ViewStockItem";
import ManageSupplier from "../Components/PharmacySuppliers/ManageSuppliers";
import TransferHistory from "../Components/PharmacyTransfer/TransferHistory";
import Profile from "../Components/Profile/Profile";
import UpdateProfile from "../Components/Profile/UpdateProfile";
import Home from "../Components/Profile/Home";
import AddStockNew from "../Components/PharmacyStocks/AddStock";
import ShiftRecordList from "../Components/ManageStaff/ShiftRecord/shift-record-list";
import ShiftRecordDetails from "../Components/ManageStaff/ShiftRecord/shift-record-details";
import GstDiary from "../Components/PharmacyManageTax/GstDiary";
import PreOrderList from "../Components/PreOrderManagement/PreOrderList";
import AddPreOrder from "../Components/PreOrderManagement/AddPreOrder";
import UpdatePreOrder from "../Components/PreOrderManagement/UpdatePreOrder";
import ManageSetting from "../Components/PharmacyManageTax/ManageSettings";
import PurchaseFromPreOrder from "../Components/PharmacyStocks/PurchaseFromPreOrder";
import PackageDetails from "../Components/PackageManagement/PackageDetails";

export const routes = [
	// Dashboard
	{ path: `${process.env.PUBLIC_URL}/dashboard`, Component: <ClinicAdminDashboard />, menu_key: 'dashboard' },

	// Change Password
	{ path: `${process.env.PUBLIC_URL}/change-password`, Component: <ChangePassword /> },

	// Sales
	{ path: `${process.env.PUBLIC_URL}/new-sales`, Component: <NewSales /> },
	{ path: `${process.env.PUBLIC_URL}/return-sales`, Component: <ReturnSales /> },
	{ path: `${process.env.PUBLIC_URL}/sales-history`, Component: <SalesHistory /> },
	{ path: `${process.env.PUBLIC_URL}/view-sale/:saleId`, Component: <ViewSale /> },
	{ path: `${process.env.PUBLIC_URL}/transactions`, Component: <Transactions /> },

	// Ledger
	// { path: `${process.env.PUBLIC_URL}/ledger`, Component: <Ledger /> },
	{ path: `${process.env.PUBLIC_URL}/patient-ledger`, Component: <PatientLedger /> },
	{ path: `${process.env.PUBLIC_URL}/view-patient-ledger/:Id`, Component: <ViewPatientLedger /> },

	// Medicine
	{ path: `${process.env.PUBLIC_URL}/items`, Component: <AddMedicine /> },
	{ path: `${process.env.PUBLIC_URL}/add-item`, Component: <AddItem /> },
	{ path: `${process.env.PUBLIC_URL}/update-medicine/:mdcId`, Component: <UpdateMedicine /> },
	{ path: `${process.env.PUBLIC_URL}/view-medicine/:mdcId`, Component: <ViewMedicine /> },

	// Inventory
	{ path: `${process.env.PUBLIC_URL}/add-inventory`, Component: <AddInventory /> },
	{ path: `${process.env.PUBLIC_URL}/adjust-inventory`, Component: <AdjustInventory /> },
	{ path: `${process.env.PUBLIC_URL}/update-inventory/:invId`, Component: <UpdateInventory /> },
	{ path: `${process.env.PUBLIC_URL}/view-inventory/:invId`, Component: <ViewInventory /> },
	{ path: `${process.env.PUBLIC_URL}/inventory-history`, Component: <InventoryHistory /> },

	// Pre orders
	{ path: `${process.env.PUBLIC_URL}/pre-order-list`, Component: <PreOrderList /> },
	{ path: `${process.env.PUBLIC_URL}/add-pre-order`, Component: <AddPreOrder /> },
	{
		path: `${process.env.PUBLIC_URL}/update-pre-order/:preorderId`,
		Component: <UpdatePreOrder />
	},
	{
		path: `${process.env.PUBLIC_URL}/purchase-from-preorder`,
		Component: <PurchaseFromPreOrder />
	},
	// purchase
	{ path: `${process.env.PUBLIC_URL}/purchase`, Component: <StockList /> },
	// { path: `${process.env.PUBLIC_URL}/add-purchase`, Component: <AddStock /> },
	{ path: `${process.env.PUBLIC_URL}/add-purchase`, Component: <AddStockNew /> },
	{ path: `${process.env.PUBLIC_URL}/return-purchase/:stkId`, Component: <ReturnPurchase /> },
	{ path: `${process.env.PUBLIC_URL}/update-purchase/:stkId`, Component: <UpdateStock /> },
	{ path: `${process.env.PUBLIC_URL}/view-purchase/:stkId`, Component: <ViewStock /> },
	{ path: `${process.env.PUBLIC_URL}/purchase-items/:stkId`, Component: <StockItemsList /> },
	{ path: `${process.env.PUBLIC_URL}/view-purchase-items/:stkId`, Component: <ViewStockItem /> },

	// Stocks
	{ path: `${process.env.PUBLIC_URL}/stock`, Component: <Stocks /> },
	{ path: `${process.env.PUBLIC_URL}/expired-stock`, Component: <StocksExpired /> },
	{ path: `${process.env.PUBLIC_URL}/min-stock`, Component: <MinStockAlert /> },
	{ path: `${process.env.PUBLIC_URL}/near-expire-stock`, Component: <NearToExpire /> },

	// Suppliers
	{ path: `${process.env.PUBLIC_URL}/suppliers`, Component: <ManageSupplier /> },

	// staff
	{ path: `${process.env.PUBLIC_URL}/manage-staff`, Component: <StaffList /> },
	// Manage Staff
	{ path: `${process.env.PUBLIC_URL}/manage-staffs/list`, Component: <StaffList />, menu_key: 'manage_admin_users', action_key: 'list' },
	{ path: `${process.env.PUBLIC_URL}/manage-staffs/add`, Component: <StaffAdd />, menu_key: 'manage_admin_users', action_key: 'add' },
	{ path: `${process.env.PUBLIC_URL}/manage-staffs/edit/:staffId`, Component: <StaffEdit />, menu_key: 'manage_admin_users', action_key: 'update' },
	{ path: `${process.env.PUBLIC_URL}/manage-staffs/view/:staffId`, Component: <StaffView />, menu_key: 'manage_admin_users', action_key: 'view' },

	// Shift Record
	{ path: `${process.env.PUBLIC_URL}/shift-record`, Component: <ShiftRecordList />, menu_key: 'staff_shift_record', action_key: 'list' },
	{ path: `${process.env.PUBLIC_URL}/shift-record/detail/:recordId`, Component: <ShiftRecordDetails />, menu_key: 'staff_shift_record', action_key: 'view' },
	// Suppliers
	{ path: `${process.env.PUBLIC_URL}/manage-tax`, Component: <ManageTax /> },
	{ path: `${process.env.PUBLIC_URL}/manage-settings`, Component: <ManageSetting /> },
	{ path: `${process.env.PUBLIC_URL}/gst-diary`, Component: <GstDiary /> },

	// package details
	{ path: `${process.env.PUBLIC_URL}/package-details`, Component: <PackageDetails /> },
	// OTC Products
	{ path: `${process.env.PUBLIC_URL}/OTC-products`, Component: <OTCProducts /> },
	{ path: `${process.env.PUBLIC_URL}/add-OTC`, Component: <AddOTC /> },
	{ path: `${process.env.PUBLIC_URL}/update-OTC/:mdcId`, Component: <UpdateOTC /> },
	{ path: `${process.env.PUBLIC_URL}/view-OTC/:mdcId`, Component: <ViewOTC /> },

	// Transfer
	{ path: `${process.env.PUBLIC_URL}/transfer-history`, Component: <TransferHistory /> },

	// profile
	// { path: `${process.env.PUBLIC_URL}/update-profile`, Component: <UpdateProfile /> },
	{ path: `${process.env.PUBLIC_URL}/update-profile`, Component: <Home /> },
	{ path: `${process.env.PUBLIC_URL}/profile`, Component: <Profile /> },

	// Manage Clinic Users
	// { path: `${process.env.PUBLIC_URL}/manage-clinic-users`, Component: <ListOfAllClinicUsers />, menu_key: 'manage_clinic_users', sub_permission_key: 'clinic_users', action_key: 'list' },
	// { path: `${process.env.PUBLIC_URL}/add-clinic-user`, Component: <AddPersonalInformation />, menu_key: 'manage_clinic_users', sub_permission_key: 'clinic_users', action_key: 'add' },
	// { path: `${process.env.PUBLIC_URL}/update-clinic-user/:userId`, Component: <UpdateClinicUser />, menu_key: 'manage_clinic_users', sub_permission_key: 'clinic_users', action_key: 'update' },
	// { path: `${process.env.PUBLIC_URL}/view-clinic-user/:userId`, Component: <ViewClinicUser />, menu_key: 'manage_clinic_users', sub_permission_key: 'clinic_users', action_key: 'view' },
	// { path: `${process.env.PUBLIC_URL}/set-consultation-fee/:userId`, Component: <ConsultationFee />, menu_key: 'manage_clinic_users', sub_permission_key: 'clinic_users', action_key: 'set_consultation_fee' },
	// { path: `${process.env.PUBLIC_URL}/linking-request-list`, Component: <LinkRequestList />, menu_key: 'manage_clinic_users', sub_permission_key: 'linking_request_list', action_key: 'list' },
	// { path: `${process.env.PUBLIC_URL}/received-linking-request`, Component: <ReceivedLinkingList />, menu_key: 'manage_clinic_users', sub_permission_key: 'received_linking_request', action_key: 'list' },

	// Calendar
	// { path: `${process.env.PUBLIC_URL}/calendar/calendar-view`, Component: <Dashboard />, menu_key: 'calendar' },

	// Manage Staff
	// { path: `${process.env.PUBLIC_URL}/manage-admin-user/list`, Component: <StaffList />, menu_key: 'manage_admin_users', action_key: 'list' },
	// { path: `${process.env.PUBLIC_URL}/manage-admin-user/add`, Component: <StaffAdd />, menu_key: 'manage_admin_users', action_key: 'add' },
	// { path: `${process.env.PUBLIC_URL}/manage-admin-user/edit/:staffId`, Component: <StaffEdit />, menu_key: 'manage_admin_users', action_key: 'update' },
	// { path: `${process.env.PUBLIC_URL}/manage-admin-user/view/:staffId`, Component: <StaffView />, menu_key: 'manage_admin_users', action_key: 'view' },

	// Services
	// { path: `${process.env.PUBLIC_URL}/services/pharmacy`, Component: <PharmacyServiceList />, menu_key: 'services', sub_permission_key: 'pharmacy', action_key: 'list' },
	// { path: `${process.env.PUBLIC_URL}/services/lab-tests`, Component: <LabTestServiceList />, menu_key: 'services', sub_permission_key: 'laboratory', action_key: 'list' },
	// { path: `${process.env.PUBLIC_URL}/services/lab-test-package`, Component: <LabTestPackageList />, menu_key: 'services', sub_permission_key: 'laboratory', action_key: 'list' },
	// { path: `${process.env.PUBLIC_URL}/services/imagings`, Component: <ImagingServiceList />, menu_key: 'services', sub_permission_key: 'imaging', action_key: 'list' },
	// { path: `${process.env.PUBLIC_URL}/services/imaging-packages`, Component: <ImagingPackageList />, menu_key: 'services', sub_permission_key: 'imaging', action_key: 'list' },
	// { path: `${process.env.PUBLIC_URL}/services/special-tests`, Component: <SpecialTestServiceList />, menu_key: 'services', sub_permission_key: 'special_test', action_key: 'list' },
	// { path: `${process.env.PUBLIC_URL}/services/special-test-package`, Component: <SpecialTestPackageList />, menu_key: 'services', sub_permission_key: 'special_test', action_key: 'list' },
	// { path: `${process.env.PUBLIC_URL}/services/procedures`, Component: <ProcedureServiceList />, menu_key: 'services', sub_permission_key: 'procedure', action_key: 'list' },
	// { path: `${process.env.PUBLIC_URL}/services/procedure-packages`, Component: <ProcedurePackageList />, menu_key: 'services', sub_permission_key: 'procedure', action_key: 'list' },

	// Manage Privilege
	// { path: `${process.env.PUBLIC_URL}/manage-privilege/list`, Component: <PrivilegeList />, menu_key: 'manage_privileges', sub_permission_key: 'admin_users_privilege', action_key: 'list' },
	// { path: `${process.env.PUBLIC_URL}/manage-privilege/add`, Component: <AddPrivilege />, menu_key: 'manage_privileges', sub_permission_key: 'admin_users_privilege', action_key: 'add' },
	// { path: `${process.env.PUBLIC_URL}/manage-privilege/update/:privilegeId`, Component: <UpdatePrivilege />, menu_key: 'manage_privileges', sub_permission_key: 'admin_users_privilege', action_key: 'update' },

	// Clinic Privilege
	// { path: `${process.env.PUBLIC_URL}/manage-privilege/clinic/list`, Component: <ClinicPrivilegeList />, menu_key: 'manage_privileges', sub_permission_key: 'clinic_users_privilege', action_key: 'list' },
	// { path: `${process.env.PUBLIC_URL}/manage-privilege/clinic/add`, Component: <AddClinicPrivilege />, menu_key: 'manage_privileges', sub_permission_key: 'clinic_users_privilege', action_key: 'add' },
	// { path: `${process.env.PUBLIC_URL}/manage-privilege/clinic/update/:privilegeId`, Component: <UpdateClinicPrivilege />, menu_key: 'manage_privileges', sub_permission_key: 'clinic_users_privilege', action_key: 'update' },


	// Manage Patient
	// { path: `${process.env.PUBLIC_URL}/manage-patient/list`, Component: <PatientList />, menu_key: 'manage_patient', action_key: 'list' },
	// { path: `${process.env.PUBLIC_URL}/manage-patient/add`, Component: <AddNewPatientForm />, menu_key: 'manage_patient', action_key: 'add' },
	// { path: `${process.env.PUBLIC_URL}/manage-patient/view/:patientID`, Component: <PatientView />, menu_key: 'manage_patient', action_key: 'view' },
	// { path: `${process.env.PUBLIC_URL}/manage-patient/emergency-view/:patientID`, Component: <ViewPatientEmergencyProfileDetails />, menu_key: 'manage_patient', action_key: 'emergency-view' },

	// Chat Module
	// { path: `${process.env.PUBLIC_URL}/chats`, Component: <Chats />, menu_key: 'chats' },

	// Appointments
	// { path: `${process.env.PUBLIC_URL}/appointments/upcoming-appointment`, Component: <AppointmentsList />, menu_key: 'appointments' },

	// Completed Appointments
	// { path: `${process.env.PUBLIC_URL}/appointments/completed-appointment`, Component: <CompletedAppointmentsList />, menu_key: 'appointments' },

	// New & Announcement
	// { path: `${process.env.PUBLIC_URL}/news-announcement-list`, Component: <NewsList />, menu_key: 'news_announcements', action_key: 'list' },
	// { path: `${process.env.PUBLIC_URL}/add-news-announcement`, Component: <AddNews />, menu_key: 'news_announcements', action_key: 'add' },
	// { path: `${process.env.PUBLIC_URL}/update-news-announcement/:newsId`, Component: <UpdateNews />, menu_key: 'news_announcements', action_key: 'update' },

	// Invoices
	// { path: `${process.env.PUBLIC_URL}/manage-account/invoices-list`, Component: <AllInvoiceList />, menu_key: 'manage_accounts', action_key: 'list' },
	// { path: `${process.env.PUBLIC_URL}/manage-account/invoice-details/:invoiceId`, Component: <InvoiceDetails />, menu_key: 'manage_accounts', action_key: 'view' },
	// { path: `${process.env.PUBLIC_URL}/manage-account/own-invoices-list`, Component: <OwnInvoiceList />, menu_key: 'manage_accounts', action_key: 'list' },
	// { path: `${process.env.PUBLIC_URL}/manage-account/raise-invoices-list`, Component: <RaisedInvoiceList />, menu_key: 'manage_accounts', action_key: 'list' },
	// { path: `${process.env.PUBLIC_URL}/manage-account/bills-list`, Component: <BillList />, menu_key: 'manage_accounts', action_key: 'list' },
	// { path: `${process.env.PUBLIC_URL}/manage-account/bill-details/:invoiceId`, Component: <BillDetails />, menu_key: 'manage_accounts', action_key: 'view' },

	// Accounts
	// { path: `${process.env.PUBLIC_URL}/accounts`, Component: <Accounts />, menu_key: 'manage_accounts', action_key: 'list' },
	// { path: `${process.env.PUBLIC_URL}/accountDetails/:accountID`, Component: <AccountDetails />, menu_key: 'manage_accounts', action_key: 'view' },

	// Notifications
	// { path: `${process.env.PUBLIC_URL}/notifications`, Component: <Notifications />, menu_key: 'notification' },

	// Settings
	// { path: `${process.env.PUBLIC_URL}/clinic_admin_settings`, Component: <ClinicAdminSettingForm />, menu_key: 'clinic_admin_settings' },

	// { path: `${process.env.PUBLIC_URL}/unauthorized`, Component: <Unauthorized /> },

];
